import policyDictionaryJson from '../dictionary/policyDictionary.json';

const getText = (path: string): string => {
  return policyDictionaryJson[path] !== undefined ? policyDictionaryJson[path] : path;
};

export default getText;
